export enum FloatingActionSize {
  SMALL = 'small',
  MID = 'mid',
}

export enum FloatingActionColor {
  PRIMARY = 'primary',
  DEFAULT = 'default',
}

export enum FloatingActionPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export type FloatingActionIcon =
  | 'ui-add-circle'
  | 'ui-arrow-down'
  | 'ui-info'
  | 'ui-list-bullet'
  | 'ui-map'
  | 'ui-refresh'
  | 'ui-search';
